const ɵ0 = () => import("./../module/template-default/template-default.module.ngfactory").then(mod => mod.TemplateDefaultModuleNgFactory), ɵ1 = () => import("./../module/template-040/template-040.module.ngfactory").then(mod => mod.Template040ModuleNgFactory);
export const templateWidgets = [
    {
        path: 'template-default',
        loadChildren: ɵ0
    },
    {
        path: 'template-040',
        loadChildren: ɵ1
    },
];
export function templateArrayToObj() {
    const result = {};
    for (const w of templateWidgets) {
        result[w.path] = w.loadChildren;
    }
    return result;
}
export { ɵ0, ɵ1 };
